// extracted by mini-css-extract-plugin
export default {"socials":"Social_socials__gsgha","telegram":"Social_telegram__jx0qN"};